import { Box } from '@mui/material';
import { CountrySelector } from './CountrySelector';
import { PhoneNumberInput } from './PhoneNumberInput';
import { phoneInputStyles } from './styles';
import { PhoneDialerInputsProps } from './types';

export const PhoneDialerInputs = ({
  selectedCountry,
  dialNumber,
  onCountryChange,
  onNumberChange,
  onClearNumber,
}: PhoneDialerInputsProps) => (
  <Box sx={phoneInputStyles.fieldsContainer}>
    <CountrySelector selectedCountry={selectedCountry} onCountryChange={onCountryChange} />
    <PhoneNumberInput dialNumber={dialNumber} onNumberChange={onNumberChange} onClearNumber={onClearNumber} />
  </Box>
);
